/* global pe */

/**
 * infobip自訂方法
 */

export default (context, inject) => {
  const infobipSetUser = () => {
    if (context.$auth.loggedIn) {
      if (typeof pe !== 'undefined' && pe) {
        const {
          APhone
        } = context.$auth.user
        pe.setPerson({ phone: `+8869${APhone.substring(2)}` })
      }
    } else {
      if (typeof pe !== 'undefined' && pe) {
        pe.forgetPerson()
      }
    }
  }

  const infobipForgetUser = () => {
    if (typeof pe !== 'undefined' && pe) {
      pe.forgetPerson()
    }
  }

  const infobipTrackEvent = (name, attr) => {
    if (typeof pe !== 'undefined' && pe) {
      pe.track(name, attr)
    }
  }

  inject('infobipSetUser', infobipSetUser)
  inject('infobipForgetUser', infobipForgetUser)
  inject('infobipTrackEvent', infobipTrackEvent)

  /**
   * Infobip SDK 初始化
   * SDK 已透過 nuxt.config.js 的 head.script 載入
   * 這裡等待 SDK 載入完成後進行初始化
   */
  if (process.client) {
    const initInfobip = () => {
      if (typeof window !== 'undefined' && window.pe) {
        window.pe.init('0c5cf67b474c8246bb920df174fcafde-82b1f4ae-4b5a-43be-b3d6-274dd72a1bef')
        console.log('Infobip SDK 初始化完成')
      } else {
        // SDK 尚未載入，延遲重試
        setTimeout(initInfobip, 100)
      }
    }

    // 等待 DOM 完全載入後再初始化
    if (document.readyState === 'complete') {
      initInfobip()
    } else {
      window.addEventListener('load', initInfobip)
    }
  }
}
